<template>
  <div :class="$style['notification']">
    <v-progress-circular
      v-if="notify === 'pending'"
      indeterminate
      color="primary"
      :class="$style.progress"
    ></v-progress-circular>
    <v-icon v-if="notify !== 'pending' && !isInteractiveTile" :class="$style.notify"
      >mdi-alert-circle</v-icon
    >
    <IconSelect
      v-if="notify !== 'pending' && isInteractiveTile"
      icon="alert-rhombus-outline"
      :class="[$style.notify, $style.alert]"
    />
    <!-- <v-icon v-else :class="$style.notify">mdi-rhombus-outline</v-icon> -->
  </div>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  components: {
    IconSelect,
  },

  props: {
    notify: {
      type: [String, Boolean],
      default: undefined,
    },

    isInteractiveTile: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
.notification {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    top: 50%;
    right: 25%;
  }

  position: absolute;
  top: 0;
  right: 10%;

  display: flex;
  align-items: stretch;
  justify-content: stretch;

  width: var(--font-base);

  height: var(--font-base);

  color: var(--red);
  font-size: var(--font-base);

  background: var(--white);
  border-radius: 50%;

  :global(.v-icon) {
    color: var(--red);
  }
}

.notify {
  width: 100% !important;
  height: 100% !important;

  font-size: inherit !important;
}

.alert {
  color: transparent;

  path {
    fill: var(--red);
  }
}

.progress {
  width: 100% !important;
  height: 100% !important;
  margin: 2px;

  font-size: inherit !important;
}
</style>
